import { jwtDecode } from 'jwt-decode'

export const decodeJwtOrNull = (token) => {
  if (typeof token !== 'string') {
    return null
  }

  const value = token.trim()
  if (value.split('.').length !== 3) {
    return null
  }

  try {
    return jwtDecode(value)
  } catch {
    return null
  }
}

export const isJwtValid = (token, nowInSeconds = Date.now() / 1000) => {
  const decodedToken = decodeJwtOrNull(token)
  return !!decodedToken?.exp && decodedToken.exp >= nowInSeconds
}

export const isJwtExpired = (token, nowInSeconds = Date.now() / 1000) => !isJwtValid(token, nowInSeconds)
